export function getSimilarity(s1, s2) {
    if (s1 === s2) return 1.0;
    if (!s1 || !s2) return 0.0;
    const set1 = new Set();
    for (let i = 0; i < s1.length - 1; i++) set1.add(s1.substring(i, i + 2));
    let matches = 0;
    for (let i = 0; i < s2.length - 1; i++) {
        if (set1.has(s2.substring(i, i + 2))) matches++;
    }
    return (2.0 * matches) / (s1.length - 1 + s2.length - 1);
}
export function getNodeTableFingerprint(tableNode) {
    const rows = (tableNode.content || []).filter((r) => r.type === 'tableRow');
    return rows.map(r => {
        const cells = r.content || [];
        return cells.map(cell => {
            let text = '';
            const extract = (n) => {
                if (n.type === 'text') text += n.text;
                if (n.attrs?.variableKey || n.attrs?.label) text += ' ' + (n.attrs.variableKey || n.attrs.label);
                if (n.content) n.content.forEach(extract);
            };
            extract(cell);
            return text.replace(/«|»|<<|>>|\[|\]|\{|\}/g, '').replace(/[^a-z0-9]/gi, '').toLowerCase();
        }).join(':::');
    }).filter(r => r.length > 0).join('###');
}
export function createTableDuplicateChecker() {
    const seenTableFingerprints = [];
    return function isTableDuplicateInPreview(fp) {
        if (!fp) return false;
        for (const existing of seenTableFingerprints) {
            if (existing === fp || getSimilarity(existing, fp) >= 0.78) return true;
        }
        return false;
    };
}
